import { QueryKey } from '@tanstack/react-query';

import { UserId } from '@arrived/models';

export const currentUserKeyFn = (): QueryKey => ['currentUser'];
export const userKeyFn = (userId: UserId): QueryKey => ['users', userId];
export const accountsPrimaryKeyFn = (userId?: UserId): QueryKey =>
  (currentUserKeyFn() as readonly unknown[]).concat([userId]).concat(['accounts', 'primary']);

export const userSsnKeyFn = (userId: UserId): QueryKey => userKeyFn(userId).concat(['ssn']);
